import './login/login.js';
import { displayMap } from './mapbox.js';
import { setupImpersonation } from './login/impersonation.js';
import { setupModal } from './components/modal.js';
import { setupCompany } from './account/company.js';
import { setupUser } from './account/user.js';
import './services/screepsDashboard.js';
import './services/beeTrackDashboard.js';

// DOM ELEMENTS
const userCardContainer = document.querySelector('.card-container');

// Setup modal functionality
setupModal();

// Setup impersonation functionality
setupImpersonation(userCardContainer);

// Setup company functionality
setupCompany();

// Setup user functionality
setupUser();
